<template>
  <v-app>
    <v-toolbar
      app
      dark
      color="primary"
    >
      <v-toolbar-side-icon class="hidden-sm-and-up" @click.stop="drawer=true"></v-toolbar-side-icon>
      <v-img
        :src="require('./assets/VIKING_WHITE_LOGO.png')"
        class="hidden-xs-only"
        max-height="40px"
        max-width="40px"
        contain
      >
      </v-img>
      <v-toolbar-title class="hidden-sm-and-up">Viking Martial Arts</v-toolbar-title>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn flat @click="$router.replace('/')">Home</v-btn>
        <v-btn flat @click="$router.replace('/signup')">Signup</v-btn>
        <v-btn flat @click="$router.replace('/pay')">Pay</v-btn>
        <v-btn flat @click="$router.replace('/camp')">Summer Camp</v-btn>
        <v-btn flat @click="$router.replace('/adaptive')">Adaptive</v-btn>
        <!-- <v-btn flat @click="$router.replace('/popup')">Winter Warrior</v-btn> -->
        <v-btn flat @click="$router.replace('/Photos')">Photos</v-btn>
        <v-btn flat @click="$router.replace('/videos')">Videos</v-btn>
        <v-btn flat @click="$router.replace('/patterns')">Patterns</v-btn>
        <v-btn flat @click="$router.replace('/about')">About</v-btn>
        <v-btn flat @click="$router.replace('/contact')">Contact</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" fixed temporary app>
      <v-list dense class="pt-0">
      <v-list-tile
        v-for="item in items"
        :key="item.title"
        @click="$router.replace(item.route)"
      >
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    </v-navigation-drawer>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer
      dark
      height="auto"
      color="primary"
      class="text-xs-center"
    >
    <v-layout row wrap align-center>
      <v-flex class="white--text px-2">© 2026 Viking Martial Arts</v-flex>
      <v-flex>

        <v-btn
          icon
          target="_blank"
          href= "https://www.facebook.com/VikingAMA/"
        >
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
        <v-btn
          icon
          target="_blank"
          href= "https://www.instagram.com/vikingmartialarts/"
        >
          <v-icon>mdi-instagram</v-icon>
        </v-btn>
        <v-btn
            color="primary"
            icon
            target="_blank"
            href= "https://www.youtube.com/channel/UCkyk8mb4Z9GsXQEXGYSlESQ"
          >
            <v-icon>mdi-youtube</v-icon>
          </v-btn>
      </v-flex>

    </v-layout>


    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      drawer: false,
      items: [
        { title: 'Home', route: '/' },
        { title: 'Signup', route: '/signup' },
        { title: 'Pay', route: '/pay' },
        // { title: 'Summer Camp', route: '/camp' },
        // { title: 'Winter Warrior', route: '/popup' },
        { title: 'Adaptive Program', route: '/adaptive' },
        { title: 'Photos', route: '/Photos' },
        { title: 'Videos', route: '/videos' },
        { title: 'Patterns', route: '/patterns' },
        { title: 'About', route: '/about' },
        { title: 'Contact', route: '/contact' }
      ]
    }
  },
  name: 'App'
}
</script>
<style>
main {
/* background: #00d2ff;
background: -webkit-linear-gradient(to bottom, #CFDEF3, #00d2ff);
background: linear-gradient(to bottom, #E3F2FD, #90CAF9); */

/* background: linear-gradient(to bottom, #E0EAFC, #56c1ff); */

/* background: #E0EAFC; */
/* background: -webkit-linear-gradient(to top, #CFDEF3, #E0EAFC); */
/* background: linear-gradient(to top, #CFDEF3, #E0EAFC); */
}
.section-title {
  border-left: 4px solid #184F9F;
  padding-left: 22px;
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue